/**
 * Entity List row tokens (Figma DS AIMS OS — node 11815:26388 / canvas 4770:5089).
 */

import { spacingClass } from '../../foundation/spacing.js';

export const entityListRootClass = 'flex w-full min-w-0 items-start justify-between';

export const entityListContentClass = [
  'flex min-w-0 flex-1 flex-col items-start justify-center',
  spacingClass.gap2x,
].join(' ');

export const entityListHeaderRowClass = 'flex w-full items-center justify-between gap-2';

export const entityListHeaderLeftClass = 'flex min-w-0 flex-wrap items-center gap-2';

export const entityListHeaderRightClass = [
  'flex shrink-0 items-center',
  spacingClass.gap2x,
].join(' ');

export const entityListTitleClass =
  'shrink-0 text-base font-semibold leading-none text-content';

export const entityListPrimaryMetaClass = 'flex min-w-0 flex-wrap items-center gap-2';

export const entityListMetaItemClass =
  'inline-flex items-center gap-1 text-[#5c5c5c] dark:text-content-secondary';

export const entityListMetaIconClass = 'shrink-0 text-[#5c5c5c] dark:text-content-secondary';

export const entityListMetaDotClass =
  'text-base leading-6 text-[#d9d9d9] dark:text-content-muted';

export const entityListMetaTextClass =
  'text-xs font-medium leading-5 text-[#5c5c5c] dark:text-content-secondary';

export const entityListCtaGroupClass = [
  'flex items-center',
  spacingClass.gap2x,
].join(' ');

export const entityListCtaDividerClass = 'h-[18px] w-px shrink-0 bg-edge dark:bg-edge-strong';

export const entityListTimestampClass =
  'text-xs font-medium leading-5 text-[#5c5c5c] dark:text-content-secondary';

export const entityListDescriptionRowClass = [
  'flex w-full items-start justify-between gap-1',
  'rounded-lg px-2 py-1',
].join(' ');

export const entityListDescriptionClass =
  'min-w-0 flex-1 text-sm font-medium leading-5 text-[#5c5c5c] dark:text-content-secondary';

export const entityListAiInsightClass = [
  'flex min-h-9 gap-2 rounded-lg border border-[#f3e9fd]',
  'bg-[#f3e9fd] px-2 py-1',
  'dark:border-purple-900/40 dark:bg-purple-950/35',
].join(' ');

export const entityListAiInsightTitleClass =
  'shrink-0 text-sm font-medium text-content dark:text-purple-100';

export const entityListAiInsightDotClass = 'text-sm font-medium text-[#2c075c] dark:text-purple-200';

export const entityListAiInsightTextClass =
  'text-xs font-medium leading-5 text-[#5c5c5c] dark:text-content-secondary';

export const entityListFooterRowClass = 'flex w-full min-w-0 items-end gap-2';

export const entityListSecondaryMetaClass = [
  'flex min-w-0 shrink-0 flex-wrap content-center items-center',
  spacingClass.gap4x,
  'rounded-lg px-2',
].join(' ');

/**
 * Tags container. `flex-1 min-w-0 overflow-hidden` is load-bearing: it makes the
 * width parent-driven and independent of its own content, which is what lets the
 * ResizeObserver in `EntityListTags` run without a measure/resize feedback loop.
 * Do not remove `flex-1` or `min-w-0`.
 */
export const entityListTagsClass = [
  'relative flex min-w-0 flex-1 shrink items-center justify-end overflow-hidden',
  spacingClass.gap2x,
].join(' ');

/** Off-screen row used to measure tag pill widths for overflow collapsing. */
export const entityListTagsMeasureClass = [
  'pointer-events-none invisible absolute left-0 top-0 flex h-0 overflow-hidden',
  spacingClass.gap2x,
].join(' ');

export const entityListTimeSeparatorClass = [
  'flex w-full items-center gap-[26px] py-2',
].join(' ');

export const entityListTimeSeparatorLabelClass =
  'shrink-0 text-xs font-semibold uppercase tracking-[0.48px] text-[#5c5c5c] dark:text-content-secondary';

export const entityListTimeSeparatorLineClass =
  'h-px min-w-0 flex-1 bg-[#d9d9d9] dark:bg-edge-strong';
